import { TUploadFile } from '@/features/transaction_items/Detail/components/Drawer/ImportTransactionDetailOptionDrawer/type';
import { useTranslation } from '@/i18n';
import { UploadFile } from '@moneyforward/ap-frontend-components';
import { TFunction } from 'i18next';
import { useCallback } from 'react';

type TValid = {
  isInvalid: boolean;
  message: string;
};

export type CsvFileSizeLimit = {
  bytes: number;
  label: string;
};

const fileValidation = (
  file: UploadFile,
  t: TFunction,
  limit: CsvFileSizeLimit
): TValid => {
  const { size } = file;
  const isInvalid = size !== undefined && size >= limit.bytes;

  return {
    isInvalid,
    message: isInvalid
      ? t(
          'transaction_items.detail.options.drawer.import_file.file_size_limit',
          { limit_size: limit.label }
        )
      : '',
  };
};

export const useValidateFiles = (limit: CsvFileSizeLimit) => {
  const { t } = useTranslation();

  return useCallback(
    (file: TUploadFile) => {
      const { isInvalid, message } = fileValidation(file, t, limit);
      return { isInvalid, message };
    },
    [t, limit]
  );
};
